<template>
    <footer>
        <div class="container">
            <navigation class="hide-mobile"/>
            <div class="right">
                <social />
                <i-tech-labs class="gray"/>
            </div>
        </div>
    </footer>
</template>

<script>
    import Navigation from './navigation.vue'
    import ITechLabs from './iTechLabs.vue'
    import Social from './social.vue'

    export default {
        name: 'AppHeader',
        components: {
            Navigation,
            ITechLabs,
            Social
        }
    }
</script>

<style lang="scss">
    footer {
        position: relative;
        display: block;
        background: #221e1f;
        padding: 2*$spacer 0;
        color: $white;

        .container {
            display: flex;
        }

        .right {

        }

        .iTechLabs {
            margin-top: $spacer;
        }

        .navigation {
            display: block;
            flex: 1 1 auto;
            margin-left: -$spacer;
            margin-right: $spacer;

            i {
                display: none;
            }

            .menu {
                display: flex;
                width: 100%;

                .menu-item {
                    flex: 1;
                    display: block;
                    font-size: 1.6rem;
                    color: $primary;
                    text-transform: uppercase;
                    margin: 0 $spacer;

                    a:hover,
                    a.router-link-active {
                         text-decoration: underline;
                    }
                }
            }

            .submenu {
                margin-top: $spacer;

                .submenu-item {
                    display: block;
                    font-size: 1.4rem;
                    color: $white;
                    text-transform: uppercase;

                    a:hover,
                    a.router-link-active {
                        text-decoration: underline;
                    }
                }
            }
        }

        .social {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            .social-item {
                display: inline;
                font-size: 1.4rem;
                margin-top: $spacer/2;

                i {
                    vertical-align: middle;
                    font-size: 1.5em;
                }

                span {
                    vertical-align: middle;
                    margin-left: $spacer/2;
                }

                &:hover span {
                    text-decoration: underline;
                }
            }

            .skype i{
                color: $skype;

                &:hover {
                    color: darken($skype, 10);
                }
            }

            .whatsapp i{
                color: $whatsapp;
                
                &:hover {
                    color: darken($whatsapp, 10);
                }
            }

            .email i{
                color: $email;

                    &:hover {
                    color: darken($email, 10);
                }
            }
        }

        @media (max-width: ($tablet)-1) {
            .right {
                width: 100%;

                .social {
                    flex: 1 1 auto;

                    h4 {
                       font-size: 3rem;
                    }

                    .social-item {
                        margin-top: $spacer;
                        font-size: 3rem;
                    }
                }

                .iTechLabs {
                    flex: 0 0 auto;
                    margin-top: $spacer;

                    .name {
                        font-size: 3rem;
                    }
                }

                .sertificates {
                    margin-left: -$spacer;
                    margin-right: -$spacer;

                    img {
                        width: 33.33%;
                        margin: 0;
                        padding: $spacer;
                        max-width: 240px;
                    }
                }
            }
        }
    }
</style>
